import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': 'Termos de Uso - CSSBuySpreadsheet.asia',
  'description': 'Termos de uso do CSSBuySpreadsheet.asia. Leia as condições para utilizar o melhor CSSBuy Spreadsheet 2026.',
  'url': `${SITE_URL}/termos`,
  'inLanguage': 'pt',
  'isPartOf': {
    '@type': 'WebSite',
    'name': 'CSSBuy Spreadsheet',
    'url': SITE_URL,
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'CSSBuy Spreadsheet',
      'item': SITE_URL,
    },
    {
      '@type': 'ListItem',
      'position': 2,
      'name': 'Termos de Uso',
      'item': `${SITE_URL}/termos`,
    },
  ],
};

export default function Termos() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={webPageSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article className="w-full pt-24 pb-14 md:pt-28 md:pb-20">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
              >
                <i className="ri-arrow-left-line text-base"></i>
                Voltar ao Início
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8">
              Termos de Uso
            </h1>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">1. Aceitação dos Termos</h2>
              <p>
                Ao acessar o <strong>CSSBuySpreadsheet.asia</strong>, você concorda com estes Termos de Uso. 
                Se você não concordar com qualquer parte destes termos, recomendamos que não utilize nosso 
                site sobre o <strong>CSSBuy Spreadsheet</strong>.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">2. Natureza do Serviço</h2>
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> é um site informativo independente que oferece 
                conteúdo sobre o <strong>CSSBuy Spreadsheet</strong>. Não somos afiliados oficialmente ao 
                CSSBuy e atuamos como um recurso comunitário para compradores internacionais.
              </p>
              <p>
                As informações disponibilizadas sobre o <strong>CSSBuy Spreadsheet 2026</strong> são 
                fornecidas com caráter informativo. Embora nos esforcemos para manter o conteúdo preciso 
                e atualizado, não garantimos a exatidão, integridade ou atualidade das informações.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">3. Links Externos</h2>
              <p>
                Nosso site contém links para o site principal do <strong>CSSBuy Sheet</strong> e outras 
                plataformas. Estes links são fornecidos para conveniência dos usuários. Não nos responsabilizamos 
                pelo conteúdo ou práticas de sites de terceiros.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">4. Limitação de Responsabilidade</h2>
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> não se responsabiliza por quaisquer perdas ou 
                danos decorrentes do uso das informações contidas neste site ou em sites vinculados. As 
                decisões de compra são de responsabilidade exclusiva do usuário.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">5. Modificações</h2>
              <p>
                Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. Recomendamos 
                que os usuários revisem periodicamente esta página para se manterem informados sobre 
                eventuais alterações.
              </p>

              <p className="text-xs text-foreground-500 mt-8">
                Última atualização: Junho de 2026
              </p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}